"use client";
import {
  useFormControl
} from "../__chunks/ZRJAYXZW.js";
import "../__chunks/XJENYSWS.js";
import "../__chunks/PLQDTVXM.js";
import "../__chunks/FMYQNSCK.js";
import {
  createElement,
  createHook,
  forwardRef,
  memo
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/form/form-field.tsx
var TagName = "input";
var useFormField = createHook(
  function useFormField2(props) {
    return useFormControl(props);
  }
);
var FormField = memo(
  forwardRef(function FormField2(props) {
    const htmlProps = useFormField(props);
    return createElement(TagName, htmlProps);
  })
);
export {
  FormField,
  useFormField
};
